export default [ 'quantityApiService', 'availabilityApiService', 'configService', (quantityApiService, availabilityApiService, configService) => {
  const getQuantity = (item, numberOfGuests = undefined) => {
    return quantityApiService.find(item.date, item.type || item.type_name, item.id, item.preferred_time, numberOfGuests)
      .then(response => response);
  };

  const getContentsQuantity = (date, startTime, endTime, packageContents) => {
    let promises = [];
    const dateFrom = `${date}T${startTime}`;
    const dateTo = `${date}T${endTime}`;

    for (const group of packageContents) {
      let groupPromises = [];
      let numberOfSuccesses = 1;

      for (let item of group) {
        item.isAvailable = false;

        if(item.number_required) {
          numberOfSuccesses = item.number_required;
        }

        switch(item.type) {
        case 'activity':
          if(configService.get('integration').preventActivityAvailability) {
            item.isAvailable = true;
            groupPromises.push(Promise.resolve(true));
          }
          break;
        case 'extra':
        case 'facility': // Temporary
          item.isAvailable = true;
          groupPromises.push(Promise.resolve(true));
          break;
        }

        if(item.isAvailable) {
          break;
        }

        groupPromises.push(availabilityApiService.requestExternalAvailability(item.type, dateFrom, dateTo, item.integration_identity)
          .then(response => {
            if(response && response.length > 0) {
              item.isAvailable = true;

              switch(item.type) {
              case 'activity':
                item.numberAvailable = Math.min(...response.map(activity => activity.quantity));
                break;
              default:
                item.numberAvailable = response.length;
                break;
              }
            }
          })
          .catch(() => {
            //
          }));
      }

      promises.push(new Promise(resolve => {
        return Promise.all(groupPromises)
          .then(() => {
            if(numberOfSuccesses <= group.filter(item => item.isAvailable).length) {
              const quantities = group.map(item => (item.numberAvailable || null))
                .filter(number => number);

              if(quantities && quantities.length) {
                resolve(Math.min(... quantities));
              }

              resolve(true);
            }

            resolve(false);
          })
      }));
    }

    return Promise.all(promises)
      .then(response => {
        if(response.length === response.filter(group => group).length) {
          const quantities = response.filter(quantity => Number.isInteger(quantity));

          if(quantities && quantities.length) {
            return Math.min(...quantities)
          }

          return true;
        }

        return false;
      });
  };

  return {
    getQuantity,
    getContentsQuantity
  };
} ];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/availability/services/quantity.service.js